<template lang="html">
    <div>
        <h4 class="mb-1">
            Products
            <span class="dark fs-small">
                <span class="pointer hoverLink ml-2" @click="deselectAll()">All</span>
                <span>/</span>
                <span class="pointer hoverLink" @click="selectAll()">None</span>
            </span>
        </h4>

        <div v-for="product in filteredProducts" class="mb-2">
            <div
                class="productRow d-flex align-items-center pointer"
                :class="{'selected':isThisProductSelected(product)}"
                @click="blacklistProduct(product)"
            >
                <div
                    class="square mr-2"
                    :style="{'background-color':selectProductColor(product).areaBackground, 'border-color':selectProductColor(product).areaBorder}"
                ></div>

                <div>{{product.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        props: {
            products: {
                type: Array,
                required: true
            }
        },
        data() {
            return {}
        },
        beforeMount() {
            this.selectCorrectProducts()
        },
        mounted() {
            this.$emit('loaded')
        },
        computed: {
            ...mapGetters([
                'getEventColors',
                'getfilterBlacklistProducts'
            ]),
            filteredProducts() {
                // INFO: evenType only applies to calendar events like sunrise sunset
                return this.products.filter(product => !product.eventType);
            },
            blacklistProducts: {
                get() {
                    return this.getfilterBlacklistProducts;
                },
                set(newVal) {
                    this.changefilterBlacklistProducts(newVal);
                }
            }
        },
        methods:{
            ...mapActions([
                'changefilterBlacklistProducts'
            ]),
            blacklistProduct(product) {
                let thisProdId = product.id;
                let clickedProduct = this.blacklistProducts.find(blacklistedProduct => blacklistedProduct.id == thisProdId);

                if (clickedProduct == undefined ){
                    this.blacklistProducts.push(product);
                } else {
                    this.blacklistProducts.splice(this.blacklistProducts.indexOf(clickedProduct), 1);
                }

                this.sectionChanged();
            },
            isThisProductSelected(product) {
                return this.blacklistProducts.find(selectedProduct => selectedProduct.id == product.id) == undefined;
            },
            sectionChanged() {
                this.$emit('change', this.blacklistProducts);
            },
            selectProductColor(product) {
                let productColorSelected = this.getEventColors.find(color => {return color.id == product.color});

                if (this.isThisProductSelected(product)) {
                    return {
                        areaBackground: productColorSelected ? productColorSelected.code : 0,
                        areaBorder: productColorSelected ? productColorSelected.codeSecundary : 0,
                    }
                } else {
                    return {
                        areaBackground: '#FFF',
                        areaBorder: null,
                    }
                }
            },
            selectAll() {
                for (var i = 0; i < this.products.length; i++) {
                    this.$set(this.blacklistProducts, i, this.products[i]);
                }

                this.sectionChanged();
            },
            deselectAll() {
                this.changefilterBlacklistProducts([])
                this.sectionChanged()
            },
            selectCorrectProducts() {
                if (this.areAllProductsBlackListed()) {
                    this.deselectAll();
                }
            },
            areAllProductsBlackListed() {
                return this.products.filter(product => {
                    return this.getfilterBlacklistProducts.find(blacklistedProduct => blacklistedProduct.id == product.id) == undefined;
                }).length == 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .productRow {
        opacity: 0.5;

        &.selected {
            opacity: 1;
        }
    }

    .square {
        width: 20px;
        height: 20px;
        border-radius: 3px;
        background-color: #FFF;
        border-color: $gray-dark;
        border-width: 1px;
        border-style: solid;
        min-width: 20px;
    }
</style>



// WEBPACK FOOTER //
// productFilter.vue?3298c70a